import React, { Component } from "react";

import ItemCreatorCheckbox from "./QuestionCreatorItemCheckTypes/ItemCreatorCheckbox/ItemCreatorCheckbox";
import ItemCreatorRadio from "./QuestionCreatorItemCheckTypes/ItemCreatorRadio/ItemCreatorRadio";
import ItemCreatorVerdadeiroFalso from "./QuestionCreatorItemCheckTypes/ItemCreatorVerdadeiroFalso/ItemCreatorVerdadeiroFalso";
import TextEditor from "../../../TextEditor/TextEditor";

import "./styles.css";

class QuestionCreatorItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newItem: this.props.itemData.newItem
    };
  }

  handleTypeChange(questionTypeId) {
    switch (questionTypeId) {
      // Múltipla Escolha
      case 2:
        return (
          <ItemCreatorRadio
            readOnly={this.props.readOnly}
            itemIndex={this.props.itemData.itemIndex}
            checkStatus={this.props.itemData.check}
            itemCheckChanger={this.props.itemCheckChanger}
          />
        );
      // Múltipla Resposta
      case 3:
        return (
          <ItemCreatorCheckbox
            readOnly={this.props.readOnly}
            itemIndex={this.props.itemData.itemIndex}
            checkStatus={this.props.itemData.check}
            itemCheckChanger={this.props.itemCheckChanger}
          />
        );
      // Verdadeiro ou Falso
      case 4:
        return (
          <ItemCreatorVerdadeiroFalso
            readOnly={this.props.readOnly}
            itemIndex={this.props.itemData.itemIndex}
            checkStatus={this.props.itemData.check}
            itemCheckChanger={this.props.itemCheckChanger}
          />
        );
      // Discursiva
      default:
        return "";
    }
  }

  handleNewItem() {
    if (this.state.newItem === true) {
      this.setState({ newItem: false });

      this.props.createNewItem(this.props.itemData.itemIndex);
    }
  }

  render() {
    if (this.props.readOnly && this.state.newItem) return null;

    return (
      <div className="question-creator-item-container">
        <div className="question-creator-item-upper-section">
          <div className="question-creator-left-section">
            {!this.state.newItem && (
              <div className="question-creator-item-check">
                {this.handleTypeChange(this.props.itemTypeId)}
              </div>
            )}
            <TextEditor
              editorType={{ name: "item", id: 3 }}
              handleNewItem={() => this.handleNewItem()}
              itemIndex={this.props.itemData.itemIndex}
              questionId={this.props.questionId}
              newItem={this.state.newItem}
              itemDescriptionChanger={this.props.itemDescriptionChanger}
              textContent={this.props.itemData.description}
              readOnly={this.props.readOnly}
            />
          </div>
          {!this.state.newItem && !this.props.readOnly && (
            <div className="question-creator-right-section">
              <button
                onClick={() =>
                  this.props.toggleFeedback(this.props.itemData.itemIndex)
                }
              >
                <i className="fa fa-comment fa-lg"></i>
              </button>
              <button
                onClick={() =>
                  this.props.removeItem(this.props.itemData.itemIndex)
                }
              >
                <i className="fa fa-trash fa-lg"></i>
              </button>
            </div>
          )}
        </div>
        {this.props.itemData.itemFeedbackOn && (
          <div className="question-creator-item-feedback-section">
            <span>feedback:</span>
            <input
              type="text"
              defaultValue={this.props.itemData.feedback}
              onChange={e =>
                this.props.itemFeedbackChanger(
                  this.props.itemData.itemIndex,
                  e.target.value
                )
              }
              disabled={this.props.readOnly}
            />
          </div>
        )}
      </div>
    );
  }
}

export default QuestionCreatorItems;
